import { useEffect, useState } from "react";
import { Plus, Pencil, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { adminCategories, adminCreateCategory, adminUpdateCategory, adminDeleteCategory, apiError } from "@/lib/api";
import { AdminHeader, PrimaryBtn, Modal, fieldCls, labelCls } from "./ui";

export default function AdminCategories() {
  const [cats, setCats] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({ nombre: "", descripcion: "" });
  const [saving, setSaving] = useState(false);

  const load = () => adminCategories().then(setCats);
  useEffect(() => { load(); }, []);

  const openNew = () => { setEditing(null); setForm({ nombre: "", descripcion: "" }); setOpen(true); };
  const openEdit = (c) => { setEditing(c); setForm({ nombre: c.nombre, descripcion: c.descripcion || "" }); setOpen(true); };

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      if (editing) { await adminUpdateCategory(editing.id, form); toast.success("Categoría actualizada."); }
      else { await adminCreateCategory(form); toast.success("Categoría creada."); }
      setOpen(false); load();
    } catch (err) { toast.error(apiError(err)); } finally { setSaving(false); }
  };
  const remove = async (c) => { if (!window.confirm(`¿Eliminar "${c.nombre}"?`)) return; await adminDeleteCategory(c.id); toast.success("Eliminada."); load(); };

  return (
    <div>
      <AdminHeader title="Categorías" subtitle={`${cats.length} categoría(s)`} action={<PrimaryBtn onClick={openNew} testId="new-category-btn"><Plus size={15} /> Nueva categoría</PrimaryBtn>} />
      <div className="rounded-xl bg-white border border-[#0f2544]/8 divide-y divide-[#0f2544]/6">
        {cats.map((c) => (
          <div key={c.id} className="flex items-center justify-between px-5 py-4" data-testid={`category-row-${c.slug}`}>
            <div>
              <div className="font-medium text-[#0f2544]">{c.nombre}</div>
              {c.descripcion && <div className="text-sm text-[#8a8a83]">{c.descripcion}</div>}
            </div>
            <div className="flex gap-1">
              <button onClick={() => openEdit(c)} className="p-2 text-[#8a8a83] hover:text-[#1f44e0]"><Pencil size={15} /></button>
              <button onClick={() => remove(c)} className="p-2 text-[#8a8a83] hover:text-red-600"><Trash2 size={15} /></button>
            </div>
          </div>
        ))}
      </div>

      <Modal open={open} onClose={() => setOpen(false)} title={editing ? "Editar categoría" : "Nueva categoría"}>
        <form onSubmit={save} className="space-y-4" data-testid="category-form">
          <div><label className={labelCls}>Nombre *</label><input required value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} className={fieldCls} data-testid="category-nombre" /></div>
          <div><label className={labelCls}>Descripción</label><textarea rows={2} value={form.descripcion} onChange={(e) => setForm({ ...form, descripcion: e.target.value })} className={fieldCls} /></div>
          <div className="flex justify-end gap-3">
            <button type="button" onClick={() => setOpen(false)} className="px-4 py-2.5 text-sm text-[#8a8a83]">Cancelar</button>
            <PrimaryBtn type="submit" disabled={saving} testId="save-category-btn">{saving ? "Guardando..." : "Guardar"}</PrimaryBtn>
          </div>
        </form>
      </Modal>
    </div>
  );
}
